/*
* @Author: abhi714
* @Date:   2024-08-21 11:15:23
* @Last Modified by:   Gemini AI
* @Last Modified time: 2026-02-05 15:54:00
*/

import React from 'react';
import moment from 'moment';
import ShipmentService from './../../services/ShipmentService/ShipmentService';

// Image imports
import loading_icon from '../../images/loading.gif';
import carton_icon from "../../images/carton.png";
import truck_icon from "../../images/truck.png";
import l_symbol_icon from "../../images/l_icon.png";
import techtopLogoIcon from  "../../images/techtop-logo.webp";
import orderSlipSample from "../../images/order-slip-sample.jpg";
import start_symbol from "../../images/start_symbol.png";
import copy_icon from "../../images/copy.png";

class TrackShipment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      isValid: false,
      shipmentData: [],
      imei: null,
      isTracking: false,
      shipDate: null,
      cartonDetails: {},
      selectedCarton: null,
      selectedShipmentNumber: null,
      company: '',
      is_login: 0,
      isLoadingDetails: false,
      carrierList: []
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getCartonDetail = this.getCartonDetail.bind(this);
    this.shipmentService = new ShipmentService();
    this.renderShipmentResult = this.renderShipmentResult.bind(this);
    this.handleGpsIdChange = this.handleGpsIdChange.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.getCarrierDetails = this.getCarrierDetails.bind(this);
    this.getCarrierList = this.getCarrierList.bind(this);

    this.bottomRef = React.createRef();
  }

  componentDidMount() {
    if (
      localStorage.getItem('techtop_user_id') != '' &&
      localStorage.getItem('techtop_user_id') != null
    ) {
      this.setState({
        company: localStorage.getItem('techtop_user_company'),
        is_login: 1
      });
      this.getCarrierList();
    }
  }

  scrollToBottom() {
    if (this.bottomRef && this.bottomRef.current) {
      window.scrollTo({
        top: this.bottomRef.current.offsetTop,
        behavior: 'smooth'
      });
    }
  }

  async getCarrierList() {
    try {
      const response = await this.shipmentService.getCarrierList();
      if (response.data.status === 'success') {
        this.setState({ carrierList: response.data.result });
      }
    } catch (error) {
      console.error("Error fetching carrier list:", error);
    }
  }

  async getCartonDetail(imei = null) {
    let cartonDetails = {};
    let carton_name = null;
    this.setState({ isLoadingDetails: true });

    imei = imei !== null ? imei : this.state.imei;
    
    let item = this.getShipDataByGpsId(imei);
    if (item) {
        item.pallets.forEach((value) => {
            if (value.gps_id === imei) {
                carton_name = value.name;
            }
        });

        const shipment_number = item.shipment_number;
        try {
          const response = await this.shipmentService.getCartonDetail({ shipment_number: shipment_number });
          if (response.data.status === 'success') {
              cartonDetails[imei] = response.data.result;
          }
        } catch (error) {
          console.error("Error fetching carton details", error);
        }

        this.setState({ 
            cartonDetails: cartonDetails,
            selectedCarton: carton_name,
            selectedShipmentNumber: shipment_number,
            isLoadingDetails: false,
            shouldScrollToBottom: true
        }, () => this.scrollToBottom());
    }
  }

  handleChange(field, e) {
    let fields = { ...this.state.fields };
    fields[field] = e.target.value;
    this.setState({ fields });
  }

  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["sale_order_number"]) {
      formIsValid = false;
      errors["sale_order_number"] = "Please enter sales order number.";
    }

    this.setState({ errors });
    return formIsValid;
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};
    let imei = '';
    
    this.setState({ shipmentData: [], errors, isValid: false });

    if (this.handleValidation()) {
      this.setState({ isTracking: true });
      try {
        const fields = { ...this.state.fields };
        fields['company_name'] = this.state.company;
        const response = await this.shipmentService.checkShipmentData(fields);
        if (response.status === 200 && response.data.status === 'success') {
          const data = response.data.result;
          
          // Process shipment statuses in parallel
          await Promise.all(data.map(async (value) => {
            value['shipment_status'] = '';
            try {
              const res = await this.shipmentService.getShipmentStatus({ sale_order_number: value.sales_order_number });
              if (res.data.status === 'success' && res.data.result.total > 0) {
                value['shipment_status'] = res.data.result.shipments[0].status;
              }
            } catch (err) { console.error(err); }

            value.pallets.forEach((pallet) => {
              if (imei === '' && pallet['gps_id'] !== '') {
                imei = pallet['gps_id'];
              }
            });
          }));

          this.setState({ 
            shipmentData: data, 
            imei: imei, 
            isValid: true, 
            isTracking: false 
          }, () => {
            if (imei) this.getCartonDetail(imei);
          });
        } else {
          errors["sale_order_number"] = response.data.message;
          this.setState({ errors, isTracking: false });
        }
      } catch (error) {
        console.error(error);
        this.setState({ isTracking: false });
      }
    }
  }

  handleGpsIdChange(e) {
    if(e.target.value) {
      this.setState({ imei: e.target.value });
      this.getCartonDetail(e.target.value);
    }
  }

  getShipDataByGpsId(gps_id=null) {
    if(gps_id !== null) {
      const { shipmentData } = this.state;
      for (const item of shipmentData) {
        for (const pallet of item.pallets) {
          if (pallet.gps_id === gps_id) {
            return item;
          }
        }
      }
    }
    return null;
  }

  copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    } else {
      let textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        document.execCommand('copy') ? res() : rej();
        textArea.remove();
      });
    }
  }

  getCarrierDetails(carrier_name) {
    const carrier = this.state.carrierList.find(c => c.name === carrier_name);
    return carrier ? carrier : null;
  }
    

  renderShipmentResult() {
    let { shipmentData, shipDate, isLoadingDetails, carrierList } = this.state; 
    return (
      <React.Fragment>
        <div className="row justify-content-center">
          <div className="col-md-10">
            <article className="motors">
              <div className="table-responsive">
                <table className="table mt-5">
                  <thead>
                    <tr>
                      <th className="text-center">Customer</th>
                      <th className="text-center">Shipment</th>
                      <th className="text-center">Date Shipped</th>
                      <th className="text-center">Carrier</th>
                      <th className="text-center">Tracking Number</th>
                      <th className="text-center">Shipment status</th>
                      <th className="text-center">Pallet Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    {shipmentData.length > 0 ? (
                      shipmentData.map((shipment, index) => {
                        const carrierDetails = this.getCarrierDetails(shipment.carrier_name);

                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td className="text-center">{shipment.customer_name}</td>
                              <td className="text-center">{shipment.shipment_number}</td>

                              <td>
                                {shipment.shipped_date
                                  ? moment(shipment.shipped_date * 1000).format('MM/DD/YYYY')
                                  : '--/--/----'}
                              </td>

                              <td className="text-center">
                                <a
                                  href={carrierDetails?.website || '#'}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {shipment.carrier_name}
                                </a>
                              </td>

                              <td className="text-center">
                                {carrierDetails?.tracking_url ? (
                                  <a
                                    href={
                                      carrierDetails?.tracking_url
                                        ? `${carrierDetails.tracking_url}${shipment.tracking_num || shipment.pro_number}`
                                        : '#'
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {shipment.tracking_num || shipment.pro_number}
                                  </a> ) :  shipment.tracking_num || shipment.pro_number }

                                {(shipment.tracking_num || shipment.pro_number) && (
                                  <img
                                    src={copy_icon}
                                    className="copy-icon"
                                    alt="copy"
                                    onClick={() =>
                                      this.copyToClipboard(
                                        shipment.tracking_num || shipment.pro_number
                                      )
                                    }
                                  />
                                )}
                              </td>

                              <td className="text-center">{shipment.shipment_status}</td>

                              <td className="text-center">
                                {shipment.pallets &&
                                Object.keys(shipment.pallets).length > 0 ? (
                                  <select
                                    className="form-control"
                                    value={this.state.imei}
                                    onChange={this.handleGpsIdChange}
                                  >
                                    <option value="">Select Pallet</option>
                                    {Object.keys(shipment.pallets).map((key) => (
                                      <option
                                        key={key}
                                        value={shipment.pallets[key].gps_id}
                                      >
                                        {shipment.pallets[key].name}
                                      </option>
                                    ))}
                                  </select>
                                ) : null}
                              </td>
                            </tr>

                            {this.state.cartonDetails[this.state.imei] &&
                            shipment.shipment_number ===
                              this.state.selectedShipmentNumber ? (
                              <tr>
                                <td colSpan="7">
                                  <table className="carton-details">
                                    <thead>
                                      <tr>
                                        <td>
                                          <div className="track-shipment-main-div">
                                            <div className="track-pin-div">
                                              <img src={start_symbol} alt="" />
                                            </div>
                                            <div className="track-carton-div">
                                              <img src={carton_icon} alt="" />
                                              {this.state.selectedCarton}
                                            </div>
                                          </div>
                                        </td>
                                        <td>Description</td>
                                        <td style={{ textAlign: 'center' }}>Qty</td>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {Object.keys(this.state.cartonDetails[this.state.imei]).map((key) => (
                                        <tr key={key}>
                                          <td style={{ width: '25%' }}>
                                            <div className="track-shipment-div">
                                              <div className="track-delivery-van-div2">
                                                <div className="track-delivery-l-img">
                                                  <img src={l_symbol_icon} alt="" />
                                                </div>
                                                <div className="track-delivery-van-img">
                                                  <img src={truck_icon} alt="" />
                                                </div>
                                                <div className="track-shipment-txt">
                                                  {
                                                    this.state.cartonDetails[
                                                      this.state.imei
                                                    ][key].model
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                          </td>

                                          <td style={{ width: '65%' }}>
                                            {
                                              this.state.cartonDetails[
                                                this.state.imei
                                              ][key].description
                                            }
                                          </td>

                                          <td
                                            style={{
                                              width: '10%',
                                              textAlign: 'center'
                                            }}
                                          >
                                            {
                                              this.state.cartonDetails[
                                                this.state.imei
                                              ][key].quantity
                                            }
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            ) : null}
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          Data not found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </div>
        {isLoadingDetails && (
          <article className="motors">
            <div className="row justify-content-center mb-3">
              <div className="col-md-10 d-flex justify-content-center">
                <img src={loading_icon} alt="loading" />
              </div>
            </div>
          </article>
        )}
        <div ref={this.bottomRef}></div>
      </React.Fragment>
    );
  }

  render() {
    let { errors, isTracking } = this.state;
    return (
      <React.Fragment>
        <main role="main" className="middle-content-area">
          <section className="tracking-section">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="default-title">
                    <div className="row">
                      <div className="col-md-6">  
                        <h1 className="m-0 color1"><img src={techtopLogoIcon} width="30" alt="logo" /> Track Your Order</h1>
                      </div>
                      <div className="col-md-6">  
                        <h2 className="m-0 color1 text-end">{this.state.company}</h2>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="common-width-div">
                        <div className="row">
                          <div className="col-md-12"> 
                            <img src={orderSlipSample} alt="Tracking-Example-Image" className="img-fluid mx-auto w-50 d-block" />
                            <p className="m-0">Use the last 6 digits of your order number from your Sales Order Confirmation to track your order</p>
                            <div className="table-responsive mt-2 tracking-table">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th colSpan="2">Enter your shipment number below</th>
                                  </tr>
                                </thead> 
                                <tbody>
                                  <tr>
                                    <td className="text-start">Insert your shipment number</td>
                                    <td>
                                      <input 
                                        type="text" 
                                        className="form-control" 
                                        name="sale_order_number" 
                                        placeholder="Shipment Number" 
                                        style={{ "backgroundColor": "#FAFFBD" }} 
                                        id="sale_order_number" 
                                        onChange={(e) => this.handleChange("sale_order_number", e)} 
                                        value={this.state.fields["sale_order_number"] || ''} 
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            this.handleSubmit(e); // Added parentheses to execute the function
                                          }
                                        }}
                                      />
                                      <span style={{ color: "red" }}>{errors["sale_order_number"]}</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan="2">If you do not know your shipment number, please contact Customer Service</td>
                                  </tr>
                                </tbody>  
                              </table>  
                            </div>
                            <button type="button" className="btn track-shipment-btn mb-3" id="trackButton" onClick={this.handleSubmit} disabled={isTracking}>
                              {isTracking ? "Processing..." : "Track Shipment"}
                            </button>
                          </div>
                        </div>    
                      </div>
                    </div>  
                  </div>
                </div>  
              </div>
            </div>
            {(this.state.isValid) && this.renderShipmentResult()}
          </section>
          <div ref={this.bottomRef}></div>
        </main>
      </React.Fragment>
    );
  }
}

export default TrackShipment;